import deliveryStyles from '~/components/organisms/products/productSingleResult/delivery.module.scss';
import { useProductContext } from '~/components/organisms/products/productSingleResult/productResultContext';
import { getLabelClassName } from '../getLabelClassName';
import { getLabelType } from '../getLabelType';

export const useDeliveryClassName = () => {
    const { result, customColorsConfiguration } = useProductContext();
    if (undefined === result.delivery || result.delivery === '') {
        return '';
    }

    const labelClassName = getLabelType(customColorsConfiguration.deliveries, result.delivery);

    if (!labelClassName) {
        return '';
    }

    return getLabelClassName(deliveryStyles, labelClassName);
};
